import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { RuleSet, Rule, QueryBuilderConfig } from 'ngx-angular-query-builder';
import * as lodash from 'lodash';
import { FilterEditorDialogResult } from '../models/filter-editor-dialog-result';
import { QueryBuilderConfigProvider } from '../query-builder-config-provider';
import { BehaviorSubject } from 'rxjs';
import {
  DebtorAccountHistorySequence
} from "@feature/_app_modules/debtor-account-history-widget/debtor-account-history-widget-types";

@Component({
  selector: 'mojo-filter-editor-dialog',
  templateUrl: './filter-editor-dialog.component.html',
})
export class FilterEditorDialogComponent implements OnInit {

  @Input()
  sysAdminFilterText: Array<string> = [];
  @Input()
  queryConfig = <QueryBuilderConfig>null;
  @Input()
  queryBuilderConfigProvider: QueryBuilderConfigProvider;
  @Input()
  minDialogWidth: number = 300;
  @Input()
  minDialogHeight: number = 250;
  @Input()
  dialogTitle: string = "Edit Filters";
  @Input()
  showRules: boolean = true;
  @Input()
  showReset: boolean = true;

  @Output()
  onSaveFilter: EventEmitter<FilterEditorDialogResult> = new EventEmitter<FilterEditorDialogResult>();
  @Output()
  onReset: EventEmitter<void> = new EventEmitter();
  @Output()
  onCancel: EventEmitter<void> = new EventEmitter();


  showDialog: boolean;
  tempFilter: RuleSet = this.getEmptyFilter();
  invalidFields: Array<string> = [];
  okButtonDisabled: boolean = false;

  ngOnInit() {
  }

  get resolvedConfig() {

    if (this.queryBuilderConfigProvider) {
      return this.queryBuilderConfigProvider.getQueryBuilderConfig();
    }

    return this.queryConfig || {fields: {}};
  }

  showFilterDialog(currentFilter: RuleSet) {
    this.tempFilter = lodash.cloneDeep(currentFilter);
    this.showDialog = true;
  }

  getEmptyFilter(): RuleSet {
    return {
      condition: 'and',
      rules: []
    } as RuleSet;

  }

  reset(): void {
    this.tempFilter = this.getEmptyFilter();
  }

  handleReset(): void {
    this.reset();
    this.onReset.emit();
  }


  validateFilter(): Array<string> {
    const errors: string[] = [];
    for (let ruleItem of this.tempFilter.rules) {
      const rule = ruleItem as Rule;
      if (!rule.hasOwnProperty('value') ||
        rule.value === 'unselected' ||
        rule.value == null ||
        (rule.operator.toLowerCase() === 'between' && Object.values(rule.value).indexOf(null) > -1)) {
        errors.push(rule.field);
      }
    }
    return errors;
  }

  saveAndClose(): void {
    this.invalidFields = this.validateFilter();

    if (this.invalidFields.length === 0) {
      const resultFilter = lodash.cloneDeep(this.tempFilter);
      this.reset();
      this.showDialog = false;
      const result = new FilterEditorDialogResult();
      result.filter = resultFilter;
      this.onSaveFilter.emit(result);
    }
  }

  cancel() {
    this.showDialog = false;
    this.reset();
    this.onCancel.emit();
  }


  getDialogStyle() {
    return {
      'minWidth.px': this.minDialogWidth,
      'minHeight.px': this.minDialogHeight,
    };
  }

  /**
   * @param newContentAreaStyle
   * Optional - for adjusting the scrollable area.
   * For custom content rendering changes.
   */

  setOkButtonDisabled(disabled: boolean) : void {
    this.okButtonDisabled = disabled;
  }

}
